import { useState, useRef, useEffect } from 'react'
import { createModel } from 'hox'
import { useMap } from 'ahooks';
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { settleConfigService } from './settleConfigService'
import { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import moment from 'moment'

export const settleConfigModel = createModel(function () {

    //列表数据源
    const [dataSource, setDataSource] = useState<any[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<any>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    //表单数据
    const [formInfo, { set: setFormInfo, get: getFormInfo }] = useMap<string, any>([]);
    //弹窗可见
    const [mode, setMode] = useState<string>("add"); //add、edit
    const [visible, setVisible] = useState<boolean>(false);
    const [paymentMethod, setPaymentMethod] = useState<string>();

    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])

    //列表数据
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: any = searchParam) => {
        const searchParams = {
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM,
            "searchItem": {
                ...searchValue
            }
        }
        let { retData } = await settleConfigService.page(searchParams)
        const { list, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(list)
    }

    //设置搜索value
    const updateSearchParam = (updateParam: any) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {})
    }

    //获取一条详情数据 Api
    const getOne = async (mode: string, id: string) => {
        let { retData } = await settleConfigService.one(id)
        const { ...formVal } = retData
        retData && setFormInfo(mode, {
            ...formVal,
            lastSettlementTime: retData.lastSettlementTime ? moment(retData.lastSettlementTime) : null,
        })
        setPaymentMethod(retData.paymentMethod);
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        visible,
        mode,
        formInfo,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        getOne,
        setVisible,
        setMode,
        setFormInfo, getFormInfo,
        paymentMethod, setPaymentMethod,
    }
})
